module.exports = __webpack_public_path__ + "static/media/icon-alert.08e7e25c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/NavNoLogout/assets/icon-alert.svg
// module id = 1841
// module chunks = 193